import { defineStore } from 'pinia';

import { apiClient } from '@/Clients/ApiClient';
import UsersService from '@/Services/UsersService';

const usersService = new UsersService(apiClient);

export const useBackerCenterPledgesStore = defineStore('backerCenterPledges', {
    state: () => ({
        userPledgesAndOrdersData: {},
        userPledgesAndOrders: [],
        isLoaded: false,
    }),
    actions: {
        async loadPledgesAndOrders(params = {}, loadMore = false) {
            const { data } = await usersService.getBackerCenterPledges(params);

            this.userPledgesAndOrdersData = data.pagedPledges;
            this.isLoaded = true;

            if (loadMore) {
                this.userPledgesAndOrders = [...this.userPledgesAndOrders, ...data.pagedPledges.pagedItems];
            }
            else {
                this.userPledgesAndOrders = data.pagedPledges.pagedItems;
            }
            return data;
        },
    },
    getters: {
        hasPledges(state) {
            return state.userPledgesAndOrders.length > 0;
        },
    },
});